/* ============================================================
   AMRITA HERBO — Main JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ── Sticky header shadow ─────────────────────────────── */
  const header = document.getElementById('SiteHeader');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile nav drawer ───────────────────────────────── */
  const mobileToggle = document.querySelector('.mobile-nav-toggle');
  const mobileNav = document.getElementById('MobileNav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('open');
      mobileToggle.setAttribute('aria-expanded', String(isOpen));
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    mobileNav.addEventListener('click', (e) => {
      if (e.target === mobileNav) {
        mobileNav.classList.remove('open');
        mobileToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  /* ── Collection sidebar (mobile) ────────────────────── */
  const openSidebarBtn = document.getElementById('OpenSidebar');
  const closeSidebarBtn = document.getElementById('CloseSidebar');
  const sidebar = document.getElementById('CollectionSidebar');

  function openSidebar() {
    if (!sidebar) return;
    sidebar.classList.add('open');
    openSidebarBtn && openSidebarBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeSidebar() {
    if (!sidebar) return;
    sidebar.classList.remove('open');
    openSidebarBtn && openSidebarBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  openSidebarBtn && openSidebarBtn.addEventListener('click', openSidebar);
  closeSidebarBtn && closeSidebarBtn.addEventListener('click', closeSidebar);
  sidebar && sidebar.addEventListener('click', (e) => {
    if (e.target === sidebar) closeSidebar();
  });

  /* ── Facet filter form — auto-submit on checkbox change ── */
  const facetForm = document.getElementById('FacetFiltersForm');
  if (facetForm) {
    facetForm.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
      cb.addEventListener('change', () => facetForm.submit());
    });

    const sortSelect = document.getElementById('SortBy');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.assign(url.toString());
      });
    }
  }

  /* ── Quick add to cart ──────────────────────────────── */
  document.querySelectorAll('.product-card__quick-add[data-variant-id]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        if (!res.ok) throw new Error('Cart error');
        btn.textContent = '✓ Added!';
        await refreshCart();
        openCartDrawer();
        setTimeout(() => {
          btn.textContent = '+ Quick Add';
          btn.disabled = false;
        }, 1800);
      } catch {
        btn.textContent = 'Error — try again';
        btn.disabled = false;
      }
    });
  });

  /* ── Cart Drawer ─────────────────────────────────────── */
  const cartDrawerEl   = document.getElementById('CartDrawer');
  const cartOverlayEl  = document.getElementById('CartDrawerOverlay');
  const cartCloseEl    = document.getElementById('CartDrawerClose');
  const cartToggleEl   = document.getElementById('CartDrawerToggle');

  function openCartDrawer() {
    if (!cartDrawerEl) return;
    cartDrawerEl.classList.add('open');
    cartDrawerEl.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCartDrawer() {
    if (!cartDrawerEl) return;
    cartDrawerEl.classList.remove('open');
    cartDrawerEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  cartToggleEl  && cartToggleEl.addEventListener('click', openCartDrawer);
  cartOverlayEl && cartOverlayEl.addEventListener('click', closeCartDrawer);
  cartCloseEl   && cartCloseEl.addEventListener('click', closeCartDrawer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && cartDrawerEl && cartDrawerEl.classList.contains('open')) {
      closeCartDrawer();
    }
  });

  function formatMoney(cents) {
    const rupees = Math.round(cents / 100);
    return '₹' + rupees.toLocaleString('en-IN');
  }

  async function refreshCart() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      syncCartBadge(cart.item_count);
      if (cartDrawerEl && cartDrawerEl.classList.contains('open')) {
        renderCartDrawer(cart);
      }
    } catch { /* silent */ }
  }

  function syncCartBadge(count) {
    document.querySelectorAll('.header-cart-count').forEach((el) => {
      el.textContent = count;
    });
  }

  function renderCartDrawer(cart) {
    const countEl    = document.getElementById('CartDrawerCount');
    const emptyEl    = document.getElementById('CartDrawerEmpty');
    const itemsEl    = document.getElementById('CartDrawerItems');
    const footEl     = document.getElementById('CartDrawerFoot');
    const subtotalEl = document.getElementById('CartDrawerSubtotal');

    if (countEl)    countEl.textContent    = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    const isEmpty = cart.item_count === 0;
    if (emptyEl) emptyEl.style.display = isEmpty ? 'flex' : 'none';
    if (itemsEl) itemsEl.style.display = isEmpty ? 'none' : 'block';
    if (footEl)  footEl.style.display  = isEmpty ? 'none' : 'flex';

    if (!isEmpty && itemsEl) {
      itemsEl.innerHTML = cart.items.map((item) => {
        const imgHtml = item.image
          ? `<img class="cart-drawer__item-img" src="${item.image}" alt="${item.title}" loading="lazy">`
          : `<div class="cart-drawer__item-img cart-drawer__item-img--placeholder"></div>`;
        const variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
          ? `<span class="cart-drawer__item-variant">${item.variant_title}</span>` : '';
        return `
          <div class="cart-drawer__item">
            <a href="${item.url}" class="cart-drawer__item-img-wrap">${imgHtml}</a>
            <div class="cart-drawer__item-info">
              <a href="${item.url}" class="cart-drawer__item-title">${item.product_title}</a>
              ${variantHtml}
              <span class="cart-drawer__item-price">${formatMoney(item.line_price)}</span>
              <div class="cart-drawer__item-row">
                <div class="cart-drawer__item-qty">
                  <button class="cart-drawer__qty-btn" data-action="minus" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Decrease">−</button>
                  <span class="cart-drawer__qty-val">${item.quantity}</span>
                  <button class="cart-drawer__qty-btn" data-action="plus" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Increase">+</button>
                </div>
                <button class="cart-drawer__item-remove" data-key="${item.key}">Remove</button>
              </div>
            </div>
          </div>`;
      }).join('');

      // Per-button bindings are no longer needed — events are delegated below.
    }
  }

  // Event delegation: works for both Liquid-rendered and JS-rendered buttons
  if (cartDrawerEl) {
    cartDrawerEl.addEventListener('click', async (e) => {
      const qtyBtn = e.target.closest('.cart-drawer__qty-btn');
      const rmBtn  = e.target.closest('.cart-drawer__item-remove');
      if (!qtyBtn && !rmBtn) return;

      e.preventDefault();
      const itemEl = (qtyBtn || rmBtn).closest('.cart-drawer__item');
      const key    = (qtyBtn || rmBtn).dataset.key;
      if (!key) return;

      // Visual: dim row, disable buttons
      if (itemEl) itemEl.classList.add('cart-drawer__item--loading');
      cartDrawerEl.querySelectorAll('.cart-drawer__qty-btn, .cart-drawer__item-remove').forEach(b => b.disabled = true);

      let newQty;
      if (rmBtn) {
        newQty = 0;
      } else {
        const current = parseInt(qtyBtn.dataset.qty, 10) || 0;
        newQty = qtyBtn.dataset.action === 'plus' ? current + 1 : Math.max(0, current - 1);
      }
      await changeCartItem(key, newQty);
    });
  }

  async function changeCartItem(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      const cart = await res.json();
      renderCartDrawer(cart);
      syncCartBadge(cart.item_count);
    } catch { /* silent */ }
    finally {
      // renderCartDrawer rebuilds buttons; re-enable on the fresh DOM just in case
      if (cartDrawerEl) cartDrawerEl.querySelectorAll('.cart-drawer__qty-btn, .cart-drawer__item-remove').forEach(b => b.disabled = false);
    }
  }

  // Legacy alias kept for any existing calls
  async function updateCartCount() { await refreshCart(); }

  // Expose for onclick attributes
  window.openCartDrawer  = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;

  /* ── PDP: thumbnail gallery ─────────────────────────── */
  const galleryMainImg = document.getElementById('GalleryMainImg');
  document.querySelectorAll('.pdp__gallery-thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (galleryMainImg) {
        galleryMainImg.src = thumb.dataset.src;
        galleryMainImg.alt = thumb.dataset.alt || '';
      }
      document.querySelectorAll('.pdp__gallery-thumb').forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  /* ── PDP: variant selector ──────────────────────────── */
  const variantBtns = document.querySelectorAll('.pdp__variant-btn');
  if (variantBtns.length > 0) {
    const productDataEl = document.getElementById('ProductPage');
    const productId = productDataEl ? productDataEl.dataset.productId : null;

    // Fetch product JSON for variant mapping
    if (productId) {
      fetch(`/products/${window.__productHandle || document.location.pathname.split('/products/')[1]}.js`)
        .then((r) => r.json())
        .then((product) => {
          window.__productData = product;
        })
        .catch(() => {});
    }

    variantBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const optionIndex = parseInt(btn.dataset.optionIndex, 10);
        const value = btn.dataset.value;

        // Update active state within group
        const group = btn.closest('.pdp__variant-options');
        group && group.querySelectorAll('.pdp__variant-btn').forEach((b) => {
          b.classList.remove('active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');

        // Update label text
        const label = document.getElementById(`VariantLabel-${optionIndex + 1}`);
        if (label) label.textContent = value;

        // Match variant from product data
        if (window.__productData) {
          const selectedOptions = [];
          document.querySelectorAll('.pdp__variant-options').forEach((grp) => {
            const activeBtn = grp.querySelector('.pdp__variant-btn.active');
            selectedOptions.push(activeBtn ? activeBtn.dataset.value : null);
          });

          const matched = window.__productData.variants.find((v) =>
            v.options.every((opt, i) => opt === selectedOptions[i])
          );

          if (matched) {
            const variantInput = document.getElementById('VariantId');
            if (variantInput) variantInput.value = matched.id;

            // Update price
            const priceEl = document.getElementById('PriceRow');
            if (priceEl) {
              const formatter = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 });
              const currentEl = priceEl.querySelector('.pdp__price-current');
              const origEl = priceEl.querySelector('.pdp__price-original');
              if (currentEl) currentEl.textContent = formatter.format(matched.price / 100);
              if (origEl && matched.compare_at_price > matched.price) {
                origEl.textContent = formatter.format(matched.compare_at_price / 100);
                origEl.style.display = '';
              } else if (origEl) {
                origEl.style.display = 'none';
              }
            }

            // Update ATC button
            const atcBtn = document.getElementById('AddToCartBtn');
            if (atcBtn) {
              atcBtn.disabled = !matched.available;
              atcBtn.textContent = matched.available ? 'Add to Cart' : 'Out of Stock';
            }
          }
        }
      });
    });
  }

  /* ── PDP: quantity stepper ──────────────────────────── */
  function setupQtyStepper() {
    const input = document.getElementById('Quantity');
    const minus = document.getElementById('QtyMinus');
    const plus  = document.getElementById('QtyPlus');
    if (!input) return;
    minus && minus.addEventListener('click', () => {
      const v = parseInt(input.value, 10);
      if (v > 1) input.value = v - 1;
    });
    plus && plus.addEventListener('click', () => {
      input.value = parseInt(input.value, 10) + 1;
    });
  }
  setupQtyStepper();

  /* ── PDP: add to cart form ──────────────────────────── */
  const productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const atcBtn = document.getElementById('AddToCartBtn');
      const originalText = atcBtn ? atcBtn.textContent : 'Add to Cart';
      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Adding…'; }
      try {
        const formData = new FormData(productForm);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });
        if (!res.ok) throw new Error('Failed');
        if (atcBtn) { atcBtn.textContent = '✓ Added to Cart!'; }
        await updateCartCount();
        setTimeout(() => {
          if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = originalText; }
        }, 2000);
      } catch {
        if (atcBtn) { atcBtn.disabled = false; atcBtn.textContent = originalText; }
      }
    });
  }

  /* ── PDP: tabs ─────────────────────────────────────── */
  document.querySelectorAll('.pdp-tabs__btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = btn.getAttribute('aria-controls');
      btn.closest('.pdp-tabs').querySelectorAll('.pdp-tabs__btn').forEach((b) => {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });
      btn.closest('.pdp-tabs').querySelectorAll('.pdp-tabs__panel').forEach((p) => {
        p.classList.remove('active');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
      const panel = document.getElementById(target);
      if (panel) panel.classList.add('active');
    });
  });

  /* ── Product recommendations (lazy load) ────────────── */
  const recommendationsSection = document.getElementById('RelatedProducts');
  if (recommendationsSection) {
    const url = recommendationsSection.dataset.url;
    const grid = document.getElementById('RecommendationsGrid');
    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newGrid = doc.getElementById('RecommendationsGrid');
        if (newGrid && grid) grid.innerHTML = newGrid.innerHTML;
      })
      .catch(() => {
        if (recommendationsSection) recommendationsSection.style.display = 'none';
      });
  }

  /* ── Fade-up entrance animation ─────────────────────── */
  const animateEls = document.querySelectorAll('[data-animate="fade-up"]');
  if (animateEls.length > 0 && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    animateEls.forEach((el) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(el);
    });
  }

  /* ── Concern carousel (Shop By Concern) ─────────────── */
  function initTrackCarousel(prevId, nextId, trackId) {
    const prev  = document.getElementById(prevId);
    const next  = document.getElementById(nextId);
    const wrap  = document.getElementById(trackId + 'Wrap') || document.querySelector('[data-track="' + trackId + '"]');
    const track = document.getElementById(trackId);
    if (!prev || !next || !track) return;

    const scrollByAmount = () => {
      const item = track.querySelector('.concern-item, .product-card');
      if (!item) return 200;
      const gap = parseInt(getComputedStyle(track).gap) || 0;
      return item.offsetWidth + gap;
    };

    next.addEventListener('click', () => {
      const container = track.parentElement;
      container.scrollBy({ left: scrollByAmount(), behavior: 'smooth' });
    });
    prev.addEventListener('click', () => {
      const container = track.parentElement;
      container.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' });
    });
  }

  initTrackCarousel('ConcernPrev', 'ConcernNext', 'ConcernTrack');

  /* ── Bestsellers: carousel + wishlist + size pills + ATC/stepper ── */
  (function initBestsellers() {
    var bsPrev  = document.getElementById('BestsellerPrev');
    var bsNext  = document.getElementById('BestsellerNext');
    var bsWrap  = document.getElementById('BestsellerTrackWrap');
    var bsTrack = document.getElementById('BestsellerTrack');

    /* Carousel nav */
    if (bsPrev && bsNext && bsWrap) {
      var bsScrollAmt = function () {
        var card = bsTrack && bsTrack.querySelector('.bs-card, .bs-feat');
        if (!card) return 326;
        return card.offsetWidth + (parseInt(getComputedStyle(bsTrack).gap) || 16);
      };
      bsNext.addEventListener('click', function () {
        bsWrap.scrollBy({ left: bsScrollAmt(), behavior: 'smooth' });
      });
      bsPrev.addEventListener('click', function () {
        bsWrap.scrollBy({ left: -bsScrollAmt(), behavior: 'smooth' });
      });
    }

    /* Wishlist — restore saved state */
    var wishlist = [];
    try { wishlist = JSON.parse(localStorage.getItem('amrita_wishlist') || '[]'); } catch { wishlist = []; }

    document.querySelectorAll('.bs-card__wish').forEach(function (btn) {
      var pid = btn.dataset.productId;
      if (wishlist.indexOf(pid) !== -1) {
        btn.classList.add('active');
      }
      btn.addEventListener('click', function () {
        var saved = [];
        try { saved = JSON.parse(localStorage.getItem('amrita_wishlist') || '[]'); } catch { saved = []; }
        var idx = saved.indexOf(pid);
        if (idx === -1) {
          saved.push(pid);
          btn.classList.add('active');
        } else {
          saved.splice(idx, 1);
          btn.classList.remove('active');
        }
        localStorage.setItem('amrita_wishlist', JSON.stringify(saved));
      });
    });

    /* Size pills — per-card selection */
    document.querySelectorAll('.bs-card__pills').forEach(function (pillsWrap) {
      pillsWrap.querySelectorAll('.bs-card__pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          pillsWrap.querySelectorAll('.bs-card__pill').forEach(function (p) {
            p.classList.remove('bs-card__pill--active');
          });
          pill.classList.add('bs-card__pill--active');

          var card = pillsWrap.closest('.bs-card');
          if (!card) return;

          /* Update ATC variant */
          var atcBtn = card.querySelector('.bs-card__atc');
          if (atcBtn && pill.dataset.variantId) {
            atcBtn.dataset.variantId = pill.dataset.variantId;
          }

          /* Update stepper variant */
          card.querySelectorAll('.bs-card__qty-btn').forEach(function (qb) {
            if (pill.dataset.variantId) qb.dataset.variantId = pill.dataset.variantId;
          });

          /* Update displayed price */
          if (pill.dataset.price) {
            var priceEl = card.querySelector('.bs-card__price-sale');
            if (priceEl) priceEl.textContent = pill.dataset.price;
          }
        });
      });
    });

    /* Add to Cart → show stepper */
    document.querySelectorAll('.bs-card__atc').forEach(function (btn) {
      btn.addEventListener('click', async function () {
        var variantId = parseInt(btn.dataset.variantId, 10);
        if (!variantId) return;
        var origLabel = btn.innerHTML;
        btn.innerHTML = 'Adding…';
        btn.disabled = true;
        try {
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          if (!res.ok) throw new Error('cart-add failed');
          var wrap = btn.closest('.bs-card__atc-wrap');
          if (wrap) {
            btn.style.display = 'none';
            btn.disabled = false;
            btn.innerHTML = origLabel;
            var stepper = wrap.querySelector('.bs-card__stepper');
            if (stepper) {
              stepper.style.display = 'flex';
              var qtyEl = stepper.querySelector('.bs-card__qty');
              if (qtyEl) qtyEl.textContent = '01';
            }
          }
          await updateCartCount();
        } catch {
          btn.innerHTML = origLabel;
          btn.disabled = false;
        }
      });
    });

    /* Qty stepper ± */
    document.querySelectorAll('.bs-card__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', async function () {
        var stepper = btn.closest('.bs-card__stepper');
        var qtyEl = stepper && stepper.querySelector('.bs-card__qty');
        if (!qtyEl) return;
        var qty = parseInt(qtyEl.textContent, 10) || 1;
        var variantId = parseInt(btn.dataset.variantId, 10);
        if (!variantId) return;

        if (btn.classList.contains('bs-card__qty-btn--minus')) {
          qty = Math.max(0, qty - 1);
        } else {
          qty += 1;
        }

        if (qty === 0) {
          /* Remove from cart → show ATC button */
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: 0 })
            });
          } catch { /* silent */ }
          var wrap = stepper.closest('.bs-card__atc-wrap');
          if (wrap) {
            stepper.style.display = 'none';
            var atcBtn = wrap.querySelector('.bs-card__atc');
            if (atcBtn) atcBtn.style.display = 'flex';
          }
          await updateCartCount();
          return;
        }

        /* Format qty as zero-padded if < 10 */
        qtyEl.textContent = qty < 10 ? '0' + qty : String(qty);
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: qty })
          });
        } catch { /* silent */ }
        await updateCartCount();
      });
    });
  })();

})();
